import { css } from 'styled-components';

import { ThemeProp } from '../theme/Themes';

export const focusedOutline = css`
  outline: 2px solid ${({ theme }: ThemeProp) => theme.colors.primary};
  outline-offset: 2px;
`;

export const focusedOutlineSecondary = css`
  outline: 2px solid ${({ theme }: ThemeProp) => theme.colors.white};
  outline-offset: 2px;
`;

export const truncateText = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`;

export const clampLines = (lines: number) => css`
  display: -webkit-box;
  -webkit-line-clamp: ${lines};
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const responsiveClampLines = (lines: number, maxBreakpoint: string) => css`
  ${truncateText}

  @media (max-width: ${maxBreakpoint}) {
    ${clampLines(lines)}
    white-space: normal;
  }
`;
